<template>
  <div>
    <div class="w-full flex justify-end mb-4">
      <div class="animate-pulse w-24" v-if="isFirstLoad">
        <div class="grid grid-cols-3 gap-4">
          <div class="col-span-2 h-2 rounded bg-gray-400"></div>
          <div class="col-span-1 h-2 rounded bg-gray-400"></div>
        </div>
      </div>
      <vs-button
        v-else
        align="right"
        icon-pack="feather"
        icon="icon-edit"
        @click="() => createUpdateModal = true">Create</vs-button>
    </div>

    <div
      v-if="isFirstLoad"
      class="animate-pulse">
      <div class="flex-1 space-y-6 py-1">
        <div class="h-2 rounded bg-gray-400"></div>
        <div class="space-y-3">
          <div class="grid grid-cols-3 gap-4">
            <div class="col-span-2 h-2 rounded bg-gray-400"></div>
            <div class="col-span-1 h-2 rounded bg-gray-400"></div>
          </div>
          <div class="h-2 rounded bg-gray-400"></div>
        </div>
      </div>
    </div>
    <vs-table
      v-else
      ref="table"
      :sst="true"
      :data="rules"
      :noDataText="noDataText"
      >
      <template slot="thead">
        <vs-th v-if="!isTierCosting">Discount Title</vs-th>
        <vs-th v-if="!isTierCosting">Discount Type</vs-th>
        <vs-th v-if="!isTierCosting">Discount Value</vs-th>
        <vs-th v-if="!isTierCosting">Discount Price</vs-th>
        <vs-th>Min. Qty</vs-th>
        <vs-th>Max. Qty</vs-th>
        <vs-th v-if="!isTierCosting">Display Message Min.</vs-th>
        <vs-th v-if="!isTierCosting">Display Message Max.</vs-th>
        <vs-th v-if="!isTierCosting">Min. Purchase Amount</vs-th>
        <vs-th v-if="isTierCosting">Fresh Price</vs-th>
        <vs-th v-if="isTierCosting">Cost Price</vs-th>
        <vs-th>Actions</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].discount_title" v-if="!isTierCosting">
            {{
            data[indextr].discount_title
            }}
          </vs-td>
          <vs-td :data="data[indextr].discount_type" v-if="!isTierCosting">
            {{
            data[indextr].discount_type
            }}
          </vs-td>
          <vs-td :data="data[indextr].discount_value" v-if="!isTierCosting">
            {{
            data[indextr].discount_value
            }}
          </vs-td>
          <vs-td :data="data[indextr].discount_price" v-if="!isTierCosting">
            {{
            data[indextr].discount_price
            }}
          </vs-td>
          <vs-td :data="data[indextr].min_qty">
            {{
            data[indextr].min_qty
            }}
          </vs-td>
          <vs-td :data="data[indextr].max_qty">
            {{
            data[indextr].max_qty
            }}
          </vs-td>
          <vs-td :data="data[indextr].display_message_min" v-if="!isTierCosting">
            {{
            data[indextr].display_message_min
            }}
          </vs-td>
          <vs-td :data="data[indextr].display_message_max" v-if="!isTierCosting">
            {{
            data[indextr].display_message_max
            }}
          </vs-td>
          <vs-td :data="data[indextr].minimum_purchase_amount" v-if="!isTierCosting">
            {{
            data[indextr].minimum_purchase_amount
            }}
          </vs-td>
          <vs-td :data="data[indextr].fresh_price" v-if="isTierCosting">
            <div v-if="hasProductPrices(tr)">
              <div v-for="item in tr.productPrices" :key="item.productId" class="price-row">
                <span class="price-name">{{ getProductName(item.productId) }}</span>
                <span class="price-highlight">{{ item.fresh_price }}</span>
              </div>
            </div>
            <div v-else class="price-right">
              <span class="price-highlight">{{ tr.fresh_price }}</span>
            </div>
          </vs-td>
          <vs-td :data="data[indextr].cost_price" v-if="isTierCosting">
            <div v-if="hasProductPrices(tr)">
              <div v-for="item in tr.productPrices" :key="item.productId" class="price-row">
                <span class="price-name">{{ getProductName(item.productId) }}</span>
                <span class="price-highlight">{{ item.cost_price }}</span>
              </div>
            </div>
            <div v-else class="price-right">
              <span class="price-highlight">{{ tr.cost_price }}</span>
            </div>
          </vs-td>
          <vs-td :data="data[indextr]._id">
            <div class="flex items-center justify-start space-x-2">
              <vx-tooltip text="Update" position="left" >
                <vs-button
                  type="border"
                  size="small"
                  @click="openPopupHandler(indextr, 'edit')"
                  icon-pack="feather"
                  icon="icon-edit"
                ></vs-button>
              </vx-tooltip>
              <vx-tooltip text="Delete" position="left">
                <vs-button
                  type="border"
                  size="small"
                  color="danger"
                  @click="openPopupHandler(indextr, 'delete')"
                  icon-pack="feather"
                  icon="icon-trash"
                ></vs-button>
              </vx-tooltip>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <vs-popup
      :active.sync="createUpdateModal"
      class="rule-create-update-modal">
      <div class="p-6">
        <vs-card class="mb-0">
          <div class="w-full" slot="header">
            <h6 class="font-bold">Rule details</h6>
          </div>
          <form
            data-vv-scope="rule"
            :class="{'hidden': isTierCosting}">
            <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
              <!-- Discount Title -->
              <vs-col vs-lg="5" vs-sm="5" vs-xs="12" class="sm:mr-2">
                <vs-input
                  :success="!errors.first('rule.discount_title') && details.discount_title != ''"
                  val-icon-success="done"
                  val-icon-danger="error"
                  :danger="!!errors.first('rule.discount_title')"
                  v-validate="'required'"
                  name="discount_title"
                  data-vv-name="discount_title"
                  label="Discount Title"
                  class="custom-input w-full"
                  :danger-text="errors.first('rule.discount_title') ? 'Discount title is required': ''"
                  v-model="details.discount_title" />
              </vs-col>

              <!-- Discount Price -->
              <vs-col vs-lg="5" vs-sm="5" vs-xs="12" class="custom-input">
                <label class="custom-label">Discount Price</label>
                <vs-select
                  v-model="details.discount_price"
                  class="w-full"
                  autocomplete
                  name="discount_price"
                  val-icon-success="done"
                  :danger="!!errors.first('rule.discount_price')"
                  :danger-text="errors.first('rule.discount_price') ? 'Discount Price is required' : ''"
                  :success="!errors.first('rule.discount_price') && details.discount_price != ''"
                  val-icon-danger="error"
                  v-validate="'required'">
                  <vs-select-item :key="index" :value="item.value" :text="item.label"
                    v-for="(item, index) in discountPriceEnum" />
                </vs-select>
              </vs-col>
            </vs-row>

            <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
              <!-- Minimum Qty -->
              <vs-col vs-lg="5" vs-sm="5" vs-xs="12" class="sm:mr-2">
                <vs-input
                  type="number"
                  :success="!errors.first('rule.min_qty')"
                  val-icon-success="done"
                  val-icon-danger="error"
                  :danger="!!errors.first('rule.min_qty')"
                  v-validate="'required'"
                  name="min_qty"
                  data-vv-as="Minimum Qty"
                  label="Minimum Qty"
                  class="custom-input w-full"
                  :danger-text="errors.first('rule.min_qty') ? 'Min. qty is required' : ''"
                  v-model="details.min_qty" />
              </vs-col>

              <!-- Maximum Qty -->
              <vs-col vs-lg="5" vs-sm="5" vs-xs="12">
                <vs-input
                  type="number"
                  :success="!errors.first('rule.max_qty')"
                  val-icon-success="done"
                  val-icon-danger="error"
                  :danger="!!errors.first('rule.max_qty')"
                  v-validate="'required'"
                  name="max_qty"
                  data-vv-as="Maximum Qty"
                  label="Maximum Qty"
                  class="custom-input w-full"
                  :danger-text="errors.first('rule.max_qty') ? 'Max. qty is required' : ''"
                  v-model="details.max_qty" />
              </vs-col>
            </vs-row>

            <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
              <!-- Minimum Purchase Amnt -->
              <vs-col vs-lg="5" vs-sm="5" vs-xs="12" class="sm:mr-2">
                <vs-input
                  type="number"
                  :success="!errors.first('rule.minimum_purchase_amount')"
                  val-icon-success="done"
                  val-icon-danger="error"
                  :danger="!!errors.first('rule.minimum_purchase_amount')"
                  v-validate="'required'"
                  name="minimum_purchase_amount"
                  data-vv-as="Minimum Purchase Amount"
                  label="Minimum Purchase Amount"
                  class="custom-input w-full"
                  :danger-text="errors.first('rule.minimum_purchase_amount') ? 'Min. purchase amnt is required': ''"
                  v-model="details.minimum_purchase_amount" />
              </vs-col>

              <!-- Display Message Min. -->
              <vs-col vs-lg="5" vs-sm="5" vs-xs="12">
                <vs-input
                  :success="!errors.first('rule.display_message_min') && details.display_message_min != ''"
                  val-icon-success="done"
                  val-icon-danger="error"
                  :danger="!!errors.first('rule.display_message_min')"
                  v-validate="'required'"
                  name="display_message_min"
                  data-vv-as="Display Message Min."
                  label="Display Message Min."
                  class="custom-input w-full"
                  :danger-text="errors.first('rule.display_message_min') ? 'Display message min. is required': ''"
                  v-model="details.display_message_min" />
              </vs-col>
            </vs-row>

            <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
              <!-- Display Message Max. -->
              <vs-col vs-lg="5" vs-sm="5" vs-xs="12" class="sm:mr-2">
                <vs-input
                  :success="!errors.first('rule.display_message_max') && details.display_message_max != ''"
                  val-icon-success="done"
                  val-icon-danger="error"
                  :danger="!!errors.first('rule.display_message_max')"
                  v-validate="'required'"
                  name="display_message_max"
                  data-vv-as="Display Message Max."
                  label="Display Message Max."
                  class="custom-input w-full"
                  :danger-text="errors.first('rule.display_message_max') ? 'Display message max. is required' : ''"
                  v-model="details.display_message_max" />
              </vs-col>

              <!-- Discount Type -->
              <vs-col vs-lg="5" vs-sm="5" vs-xs="12" class="custom-input">
                <label class="custom-label">Discount Type</label>
                <vs-select
                  v-model="details.discount_type"
                  class="w-full"
                  autocomplete
                  name="discount_type"
                  val-icon-success="done"
                  :danger="!!errors.first('rule.discount_type')"
                  :danger-text="errors.first('rule.discount_type') ? 'Discount Type is required' : ''"
                  :success="!errors.first('rule.discount_type') && details.discount_type != ''"
                  val-icon-danger="error"
                  v-validate="'required'">
                  <vs-select-item :key="index" :value="item.value" :text="item.label"
                    v-for="(item, index) in discountTypeEnum" />
                </vs-select>
              </vs-col>
            </vs-row>

            <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
              <!-- Discount Value -->
              <vs-col vs-lg="5" vs-sm="5" vs-xs="12" class="sm:mr-2">
                <vs-input
                  type="number"
                  :success="!errors.first('rule.discount_value')"
                  val-icon-success="done"
                  val-icon-danger="error"
                  :danger="!!errors.first('rule.discount_value')"
                  v-validate="'required'"
                  name="discount_value"
                  data-vv-as="Discount Value"
                  label="Discount Value"
                  class="custom-input w-full"
                  :danger-text="errors.first('rule.discount_value') ? 'Discount value is required' : ''"
                  v-model="details.discount_value" />
              </vs-col>
            </vs-row>

            <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12" class="space-x-4">
              <vs-button
                size="lg"
                color="primary"
                class="flex-1"
                @click="handleSave"
              >Save</vs-button>
              <vs-button class="flex-1" size="lg" color="danger" @click="createUpdateModal = false">Cancel</vs-button>
            </vs-row>
          </form>

          <form
            data-vv-scope="promo"
            :class="{'hidden': !isTierCosting}">
            <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
              <!-- Discount Title -->
              <vs-col vs-lg="5" vs-sm="5" vs-xs="12" class="sm:mr-2">
                <vs-input
                  :success="!errors.first('promo.discount_title') && details.discount_title != ''"
                  val-icon-success="done"
                  val-icon-danger="error"
                  :danger="!!errors.first('promo.discount_title')"
                  v-validate="'required'"
                  name="discount_title"
                  data-vv-name="discount_title"
                  label="Title"
                  class="custom-input w-full"
                  :danger-text="errors.first('promo.discount_title') ? 'Discount title is required': ''"
                  v-model="details.discount_title" />
              </vs-col>

              <!-- Discount Price -->
              <vs-col vs-lg="5" vs-sm="5" vs-xs="12" class="custom-input">
                <label class="custom-label">Discount Price</label>
                <vs-select
                  v-model="details.discount_price"
                  class="w-full"
                  autocomplete
                  name="discount_price"
                  data-vv-name="discount_price"
                  data-vv-as="Discount Price"
                  val-icon-success="done"
                  :danger="!!errors.first('promo.discount_price')"
                  :danger-text="errors.first('promo.discount_price') ? 'Discount Price is required' : ''"
                  :success="!errors.first('promo.discount_price') && details.discount_price != ''"
                  val-icon-danger="error"
                  v-validate="'required'">
                  <vs-select-item :key="index" :value="item.value" :text="item.label"
                    v-for="(item, index) in discountPriceEnum" />
                </vs-select>
              </vs-col>
            </vs-row>

            <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
              <!-- Minimum Qty -->
              <vs-col vs-lg="5" vs-sm="5" vs-xs="12" class="sm:mr-2">
                <vs-input
                  type="number"
                  :success="!errors.first('promo.min_qty')"
                  val-icon-success="done"
                  val-icon-danger="error"
                  :danger="!!errors.first('promo.min_qty')"
                  v-validate="'required'"
                  name="min_qty"
                  data-vv-as="Minimum Qty"
                  label="Minimum Qty"
                  class="custom-input w-full"
                  :danger-text="errors.first('promo.min_qty') ? 'Min. qty is required' : ''"
                  v-model="details.min_qty" />
              </vs-col>

              <!-- Maximum Qty -->
              <vs-col vs-lg="5" vs-sm="5" vs-xs="12">
                <vs-input
                  type="number"
                  :success="!errors.first('promo.max_qty')"
                  val-icon-success="done"
                  val-icon-danger="error"
                  :danger="!!errors.first('promo.max_qty')"
                  v-validate="'required'"
                  name="max_qty"
                  data-vv-as="Maximum Qty"
                  label="Maximum Qty"
                  class="custom-input w-full"
                  :danger-text="errors.first('promo.max_qty') ? 'Max. qty is required' : ''"
                  v-model="details.max_qty" />
              </vs-col>
            </vs-row>

            <!-- Global Fresh/Cost Price (only when products switch is OFF) -->
            <vs-row v-if="!productIsEqual" vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
              <!-- Fresh Price -->
              <vs-col vs-lg="5" vs-sm="5" vs-xs="12" class="sm:mr-2">
                <vs-input
                  type="number"
                  :success="!errors.first('promo.fresh_price')"
                  val-icon-success="done"
                  val-icon-danger="error"
                  :danger="!!errors.first('promo.fresh_price')"
                  v-validate="'required'"
                  name="fresh_price"
                  data-vv-name="fresh_price"
                  label="Fresh Price"
                  class="custom-input w-full"
                  :danger-text="errors.first('promo.fresh_price') ? 'Fresh Price is required' : ''"
                  v-model="details.fresh_price" />
              </vs-col>

              <!-- Cost Price -->
              <vs-col vs-lg="5" vs-sm="5" vs-xs="12">
                <vs-input
                  type="number"
                  :success="!errors.first('promo.cost_price')"
                  val-icon-success="done"
                  val-icon-danger="error"
                  :danger="!!errors.first('promo.cost_price')"
                  v-validate="'required'"
                  name="cost_price"
                  data-vv-name="cost_price"
                  label="Cost Price"
                  class="custom-input w-full"
                  :danger-text="errors.first('promo.cost_price') ? 'Cost Price is required' : ''"
                  v-model="details.cost_price" />
              </vs-col>
            </vs-row>

            <!-- Per-Product Fresh/Cost Price (only when products switch is ON) -->
            <div v-if="productIsEqual && selectedProducts.length > 0">
              <vs-divider class="my-4"></vs-divider>
              <div class="mb-4">
                <h6 class="font-bold mb-2">Product-Specific Pricing</h6>
                <p class="text-gray-500 text-sm">Set fresh price and cost price for each selected product. All fields are required.</p>
              </div>
              
              <div class="product-pricing-container">
                <div 
                  v-for="product in productsWithPricing"
                  :key="product._id"
                  class="mb-4 p-4 border border-gray-200 rounded-md bg-gray-50">
                  <h6 class="font-medium mb-3 text-primary">{{ product.name }}</h6>
                  <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
                    <vs-col vs-lg="5" vs-sm="5" vs-xs="12" class="sm:mr-2">
                      <vs-input
                        type="number"
                        step="0.01"
                        :name="`product_fresh_price_${product._id}`"
                        :data-vv-name="`product_fresh_price_${product._id}`"
                        label="Fresh Price"
                        placeholder="0.00"
                        class="custom-input w-full"
                        :value="getProductFreshPrice(product._id)"
                        @input="setProductFreshPrice(product._id, $event)" />
                    </vs-col>

                    <vs-col vs-lg="5" vs-sm="5" vs-xs="12">
                      <vs-input
                        type="number"
                        step="0.01"
                        :name="`product_cost_price_${product._id}`"
                        :data-vv-name="`product_cost_price_${product._id}`"
                        label="Cost Price"
                        placeholder="0.00"
                        class="custom-input w-full"
                        :value="getProductCostPrice(product._id)"
                        @input="setProductCostPrice(product._id, $event)" />
                    </vs-col>
                  </vs-row>
                </div>
              </div>
            </div>

            <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12" class="space-x-4">
              <vs-button
                size="lg"
                color="primary"
                class="flex-1"
                @click="handleSave"
              >Save</vs-button>
              <vs-button class="flex-1" size="lg" color="danger" @click="createUpdateModal = false">Cancel</vs-button>
            </vs-row>
          </form>
        </vs-card>
      </div>
    </vs-popup>
    <vs-popup :active.sync="deleteModal" title="Delete Rule">
      <div class="p-6">
        <p class="text-center text-black text-lg font-medium mb-6">Are you sure you want to delete this rule?</p>
        <div class="flex items-center justify-between space-x-4">
          <vs-button
            size="lg"
            color="primary"
            class="flex-1"
            @click="handleDelete"
          >Yes</vs-button>
          <vs-button class="flex-1" size="lg" color="danger" @click="deleteModal = false">Cancel</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  props: {
    rules: {
      type: Array,
      required: true,
      default: () => ([]),
    },
    isFirstLoad: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    isTierCosting: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    productIsEqual: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    selectedProducts: {
      type: Array,
      required: false,
      default: () => ([]),
    },
  },
  data() {
    return {
      noDataText: 'No rules available.',
      createUpdateModal: false,
      deleteModal: false,
      selectedId: '',
      details: {
        discount_title: '',
        discount_price: '',
        min_qty: 0,
        max_qty: 0,
        minimum_purchase_amount: 0,
        display_message_min: '',
        display_message_max: '',
        discount_type: 'percentage',
        discount_value: null,
        cost_price: null,
        fresh_price: null,
        productPrices: [],
        _productPricesMap: null,
      },
      discountPriceEnum: [
        { label: 'List Price', value: 'List Price' },
        { label: 'Nurse Price', value: 'Nurse Price' },
        { label: 'Doctor Price', value: 'Doctor Price' },
        { label: 'RRP', value: 'RRP' },
      ],
      discountTypeEnum: [
        { label: 'percentage', value: 'percentage' },
        { label: 'fix', value: 'fix' },
      ],
    };
  },
  computed: {
    productsWithPricing() {
      if (!this.productIsEqual || !this.selectedProducts.length) return [];
      if (!Array.isArray(this.details.productPrices) || !this.details.productPrices.length) return [];
      
      // Build Set for O(1) lookup
      const priceProductIds = new Set(this.details.productPrices.map(p => p.productId));
      
      return this.selectedProducts.filter(product => priceProductIds.has(product._id));
    },
  },
  methods: {
    buildProductPricesMap() {
      if (!this.details._productPricesMap && Array.isArray(this.details.productPrices)) {
        this.details._productPricesMap = this.details.productPrices.reduce((map, item) => {
          if (item.productId) {
            map[item.productId] = item;
          }
          return map;
        }, {});
      }
      return this.details._productPricesMap || {};
    },
    hasProductPrices(rule) {
      return rule.productPrices && Array.isArray(rule.productPrices) && rule.productPrices.length > 0;
    },
    getProductName(productId) {
      const match = (this.selectedProducts || []).find(p => p && p._id === productId);
      return match ? match.name : productId;
    },
    getProductFreshPrice(productId) {
      const pricesMap = this.buildProductPricesMap();
      const item = pricesMap[productId];
      
      if (item && item.fresh_price !== null && item.fresh_price !== undefined) {
        return item.fresh_price;
      }
      
      return '';
    },
    setProductFreshPrice(productId, value) {
      // Convert to number for API, handle empty string
      const num = value === '' || value == null  ? null : Number(value);
      if (!this.details.productPrices) {
        this.$set(this.details, 'productPrices', []);
      }
      
      const pricesMap = this.buildProductPricesMap();
      const existingItem = pricesMap[productId];
      
      if (existingItem) {
        // Update existing item
        this.$set(existingItem, 'fresh_price', num);
      } else {
        // Add new item and invalidate cache
        this.details.productPrices.push({ productId, fresh_price: num, cost_price: null });
        this.details._productPricesMap = null;
      }
    },
    getProductCostPrice(productId) {
      const pricesMap = this.buildProductPricesMap();
      const item = pricesMap[productId];
      
      if (item && item.cost_price != null) {
        return item.cost_price;
      }
      
      return '';
    },
    setProductCostPrice(productId, value) {
      // Convert to number for API, handle empty string
      const num = value === '' || value == null ? null : Number(value);
      if (!this.details.productPrices) {
        this.$set(this.details, 'productPrices', []);
      }
      
      const pricesMap = this.buildProductPricesMap();
      const existingItem = pricesMap[productId];
      
      if (existingItem) {
        // Update existing item
        this.$set(existingItem, 'cost_price', num);
      } else {
        // Add new item and invalidate cache
        this.details.productPrices.push({ productId, fresh_price: null, cost_price: num });
        this.details._productPricesMap = null;
      }
    },
    async handleSave() {
      const scope = this.isTierCosting ? 'promo.*' : 'rule.*';
      const isValid = await this.$validator.validate(scope);

      if (!isValid) return;

      // Validate discount_price is set for tier cost rules
      if (this.isTierCosting && !this.details.discount_price) {
        this.$vs.notify({
          title: 'Validation Error',
          text: 'Discount Price is required',
          color: 'warning',
        });
        return;
      }

      // Validate product-specific prices if tier costing and products are selected
      if (this.isTierCosting && this.productIsEqual && this.selectedProducts.length > 0) {
        const pricesMap = this.buildProductPricesMap();
        
        for (const product of this.selectedProducts) {
          const prices = pricesMap[product._id];
          if (!prices || prices.fresh_price == null || prices.cost_price == null) {
            this.$vs.notify({
              title: 'Validation Error',
              text: `Please set both fresh price and cost price for ${product.name}`,
              color: 'warning',
            });
            return;
          }
        }
      }

      if (typeof this.selectedId === 'number') return this.updateRule();

      return this.createRule();
    },
    createRule() {
      try {
        const extraDetails = this.isTierCosting ?
          { 
            discount_value: 0, 
            discount_price: this.details.discount_price, 
            discount_type: 'fix', 
            display_message_min: 'n/a', 
            display_message_max: 'n/a',
          }
        : {};

        this.rules.push({
          ...this.details,
          ...extraDetails,
        });

        setTimeout(() => {
          this.$vs.notify({
            title: 'Success',
            text: 'Discount rule created successfully',
            color: 'success',
          });

          this.createUpdateModal = false;
        }, 200);
      } catch (err) {
        this.$vs.notify({
          title: 'Failed',
          text: 'Failed to create discount rule.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      }
    },
    updateRule() {
      try {
        this.rules[this.selectedId] = this.details;

        setTimeout(() => {
          this.$vs.notify({
            title: 'Success',
            text: 'Discount rule updated successfully',
            color: 'success',
          });

          this.createUpdateModal = false;
        }, 200);
      } catch (err) {
        this.$vs.notify({
          title: 'Failed',
          text: 'Failed to update discount rule.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      }
    },
    handleDelete() {
      try {
        this.rules.splice(this.selectedId, 1);

        setTimeout(() => {
          this.$vs.notify({
            title: 'Success',
            text: 'Discount rule deleted successfully',
            color: 'success',
          });

          this.deleteModal = false;
        }, 200);
      } catch (err) {
        this.$vs.notify({
          title: 'Failed',
          text: 'Failed to delete discount rule.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      }
    },
    openPopupHandler(index, mode) {
      if (mode === 'delete') {
        this.deleteModal = true;
      } else {
        this.createUpdateModal = true;
      }

      this.selectedId = index;
      const clonedRule = cloneDeep(this.rules[index]);
      
      // Ensure productPrices exists as array
      if (!clonedRule.productPrices) {
        clonedRule.productPrices = [];
      }
      
      // Set default discount_price for tier cost rules if missing
      if (this.isTierCosting && !clonedRule.discount_price) {
        clonedRule.discount_price = 'List Price';
      }
      
      this.details = clonedRule;
      
      this.$nextTick(() => {
        this.initializeProductPrices();
      });
    },
    clearFields() {
      this.details = {
        discount_title: '',
        discount_price: '',
        min_qty: 0,
        max_qty: 0,
        minimum_purchase_amount: 0,
        display_message_min: '',
        display_message_max: '',
        discount_type: 'percentage',
        discount_value: null,
        cost_price: null,
        fresh_price: null,
        productPrices: [],
        _productPricesMap: null,
      };
      this.selectedId = '';
      this.initializeProductPrices();
    },
    initializeProductPrices() {
      if (this.isTierCosting && this.productIsEqual) {
        // Ensure productPrices exists as array
        if (!this.details.productPrices) {
          this.$set(this.details, 'productPrices', []);
        }
        
        // Build a Set of existing productIds for O(1) lookup
        const existingProductIds = new Set(
          this.details.productPrices.map(p => p.productId)
        );
        
        // Only add missing products, preserve existing values
        this.selectedProducts.forEach(product => {
          if (!existingProductIds.has(product._id)) {
            this.details.productPrices.push({
              productId: product._id,
              fresh_price: null,
              cost_price: null,
            });
            // Invalidate cache since we modified the array
            this.details._productPricesMap = null;
          }
        });
      }
    },
  },
  watch: {
    deleteModal: function(isOpen) {
      if (!isOpen) this.clearFields();
    },
    createUpdateModal: function(isOpen) {
      if (!isOpen) this.clearFields();
      if (isOpen) {
        this.$nextTick(() => {
          this.errors.clear();
          this.initializeProductPrices();
        });
      }
    },
    selectedProducts: {
      handler(newProducts, oldProducts) {
        // Only initialize if modal is open and product list actually changed
        if (this.createUpdateModal && oldProducts && newProducts.length !== oldProducts.length) {
          this.initializeProductPrices();
        }
      },
    },
  },
};
</script>

<style lang="scss">
.custom-input {
  margin-bottom: 20px;

  .vue-daterange-picker > .form-control {
    padding: .7rem !important;
  }
}

.custom-input label,
.custom-label {
  display: block;
  padding: 5px 0;
  font-size: 12px;
}

.rule-create-update-modal {
  .vs-popup {
    width: 900px !important;
    max-width: 95vw !important;
  }
}

.border {
  border-width: 1px;
}

.border-gray-200 {
  border-color: #e2e8f0;
}

.rounded-md {
  border-radius: 0.375rem;
}

.bg-gray-50 {
  background-color: #f9fafb;
}

.text-gray-500 {
  color: #6b7280;
}

.text-primary {
  color: #3dc9b3;
}

.font-medium {
  font-weight: 500;
}

.product-pricing-container {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
    
    &:hover {
      background: #555;
    }
  }
}

.price-highlight {
  font-weight: 400;
  color: #111827;
}

.price-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
}

.price-name {
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 2px;
  flex: 1 1 auto;
}

.price-right {
  display: flex;
  justify-content: flex-end;
}

.price-highlight {
  text-align: right;
  flex: 0 0 auto;
}
</style>
